export enum UserAction {
    Idle = 0,
    EditingProject = 1
}